<template>
  <Tabs
    v-model:value="queryStore.tabValue"
    scrollable
    class="max-h-full h-full"
  >
    <TabList class="flex-shrink-0">
      <Tab value="explore">Explore</Tab>
      <Tab value="query">Query</Tab>
      <Tab value="results">Results</Tab>
      <Tab value="plot">Plot</Tab>
      <Tab value="chat">Chat <i class="pi pi-sparkles"></i></Tab>
      <div
        v-if="queryStore.tabValue === 'query'"
        class="flex-grow border-r-2 border-surface-200 dark:border-surface-700 my-2"
      ></div>
      <RunQueryButton
        v-if="queryStore.tabValue === 'query'"
        class="self-center flex-shrink-0 mx-5"
      />
    </TabList>
    <TabPanels class="flex flex-col flex-grow min-h-0 !p-0">
      <TabPanel value="explore" class="flex flex-col flex-grow min-h-0 p-0">
        <ExploreTab class="min-h-0" />
      </TabPanel>
      <TabPanel value="query" class="flex-grow max-h-full">
        <QueryTab />
      </TabPanel>
      <TabPanel value="results" class="flex flex-col flex-grow min-h-0 p-0">
        <ResultsTab />
      </TabPanel>
      <TabPanel value="plot" class="flex-grow max-h-full">
        <PlotTab />
      </TabPanel>
      <TabPanel value="chat" class="flex-grow max-h-full">
        <keep-alive>
          <ChatTab />
        </keep-alive>
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>

<script setup>
import Tabs from "primevue/tabs";
import TabList from "primevue/tablist";
import TabPanels from "primevue/tabpanels";
import TabPanel from "primevue/tabpanel";
import Tab from "primevue/tab";
import ExploreTab from "@/components/information_tabs/ExploreTab.vue";
import QueryTab from "@/components/information_tabs/QueryTab.vue";
import RunQueryButton from "@/components/RunQueryButton.vue";
import ResultsTab from "@/components/information_tabs/ResultsTab.vue";
import ChatTab from "@/components/information_tabs/ChatTab.vue";
import { useQueryStore } from "@/stores/queryStore.js";
import PlotTab from "@/components/information_tabs/PlotTab.vue";

const queryStore = useQueryStore();
</script>

<style scoped></style>
